import {
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST,
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS,
  FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS,
  UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE,
} from "./types";

import {
  fetchDriverPartnersSupportTickets,
  updateDriverPartnerSupportTicket,
} from "../../services/driverPartnerSupportService";

export const fetchDriverPartnerSupportTicketsRequest = () => ({
  type: FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST,
});

export const fetchDriverPartnerSupportTicketsSuccess = (tickets) => ({
  type: FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS,
  payload: tickets,
});

export const fetchDriverPartnerSupportTicketsFailure = (error) => ({
  type: FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE,
  payload: error,
});

export const updateDriverPartnerSupportTicketRequest = () => ({
  type: UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST,
});

export const updateDriverPartnerSupportTicketSuccess = (ticket) => ({
  type: UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS,
  payload: ticket,
});

export const updateDriverPartnerSupportTicketFailure = (error) => ({
  type: UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE,
  payload: error,
});

// Fetch Tickets
export const fetchDriverPartnersSupportTicketsAction =
  (page = 1, size = 10) =>
  async (dispatch) => {
    dispatch(fetchDriverPartnerSupportTicketsRequest());

    try {
      const response =
        await fetchDriverPartnersSupportTickets(page, size);

      if (response.success) {
        dispatch(
          fetchDriverPartnerSupportTicketsSuccess(response.data)
        );
      } else {
        dispatch(
          fetchDriverPartnerSupportTicketsFailure(
            response.error
          )
        );
      }
    } catch (error) {
      dispatch(
        fetchDriverPartnerSupportTicketsFailure(
          error.message ||
            "Failed to fetch Driver Partner Support Tickets"
        )
      );
    }
  };

// Update Ticket
export const updateDriverPartnerSupportTicketAction =
  (ticketId, payload) =>
  async (dispatch) => {
    dispatch(updateDriverPartnerSupportTicketRequest());

    try {
      const response =
        await updateDriverPartnerSupportTicket(
          ticketId,
          payload
        );

      if (response.success) {
        dispatch(
          updateDriverPartnerSupportTicketSuccess(
            response.data
          )
        );
      } else {
        dispatch(
          updateDriverPartnerSupportTicketFailure(
            response.error
          )
        );
      }

      return response;
    } catch (error) {
      const err =
        error.message ||
        "Failed to update Driver Partner Support Ticket";

      dispatch(
        updateDriverPartnerSupportTicketFailure(err)
      );

      return {
        success: false,
        error: err,
      };
    }
  };